<template>
    <v-container v-if="researchPeriod">
        <v-row>
            <v-col cols="12" order-md="2">
                <div class="d-flex justify-center justify-md-end">
                    <action-buttons
                        :state="editState"
                        :permissions="userPermission"
                        :disabled="disableButtons"
                        @save="handleSave"
                        @cancel="handleCancel"
                        @close="handleClose"
                        :is-dirty="isDirty"
                        class="d-flex justify-end"
                    />
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="valid">
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="researchPeriod.name"
                        label="Research Period Name"
                        :error-messages="validation.nameMessage"
                        @change="validate"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="8">
                    <div class="text-h6">Dealine Date</div>
                    <v-date-picker v-model="deadlineDate"></v-date-picker>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState } from 'vuex'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import { DateTime } from 'luxon'
export default {
    name: 'ResearchPeriodEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    data() {
        return {
            valid: true,
            researchPeriod: {
                name: '',
            },
            deadlineDate: '',
            startPicker: false,
            validation: {
                nameMessage: '',
                datesMessage: '',
            },
        }
    },
    props: {
        id: {
            type: [String, Number],
            required: false,
            default: undefined,
        },
    },
    watch: {
        researchPeriod: {
            deep: true,
            handler() {
                this.isDirty = true
            },
        },
        deadlineDate: {
            deep: true,
            handler() {
                this.isDirty = true
            },
        },
    },
    computed: {
        ...mapState(['user']),
        userPermission() {
            if (this.user && this.user.editResearchPeriod) {
                return this.user.editResearchPeriod.all
            } else {
                return 0
            }
        },
        editState() {
            return this.id ? 'Edit' : 'Create'
        },
    },
    mounted() {
        if (this.id) {
            this.getEvent()
        } else {
            this.newEvent()
        }
    },
    methods: {
        getEvent() {
            this.isLoading = true
            api.get(`researchPeriod/Get/${this.id}`)
                .then(res => {
                    this.researchPeriod = res
                    this.setDeadline()
                })
                .finally(() => {
                    this.isDirty = false
                    this.isLoading = false
                })
        },
        setDeadline() {
            if (this.isValidDate(this.researchPeriod.deadline)) {
                this.deadlineDate = DateTime.fromISO(this.researchPeriod.deadline).toISODate()
            }
        },
        newEvent() {
            this.researchPeriod = {}
        },
        handleSave() {
            if (!this.validate()) return
            this.isSaving = true
            let data = Object.assign({}, this.researchPeriod)
            data.deadline = DateTime.fromISO(this.deadlineDate).toISODate()
            let endpoint = this.id ? 'update' : 'create'
            api.post(`researchPeriod/${endpoint}`, data)
                .then(() => {
                    this.showSnackbar('success', `Research Period ${endpoint}d`)
                    this.isDirty = false
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        isValidDate(value) {
            if (!value || value === 'Invalid DateTime' || (DateTime.isDateTime(value) && !value.isValid)) {
                return false
            }
            return true
        },
        handleCancel() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        handleClose() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        validate() {
            if (!this.researchPeriod.name || !this.researchPeriod.name.trim().length > 0) {
                this.validation.nameMessage = 'Name is required'
                return false
            }
            return true
        },
    },
}
</script>
